import { apiLocal, apiMj } from '@/services/Api'

function parse (objId, end) {
  return apiLocal().get(`parse/parsemj?objId=${objId}&end=${end}`)
}

function getSpoList (limit, skip, keys) {
  return apiMj().get(`classes/Reports`, {
    params: {
      where: {ringDataVer: {$exists: true}},
      order: '-updatedAt',
      limit: limit || null,
      skip: skip || 0,
      keys: keys || 'objectId,tempSleepId,ringDataVer,updatedAt,createdAt'
    }
  })
}

function getSpoListCounts () {
  return apiMj().get(`classes/Reports`, {
    params: {
      where: {ringDataVer: {$exists: true}},
      limit: 0,
      count: 1 // 获取总计数
    }
  })
}

function getByObjectId (objectId) {
  return apiMj().get(`classes/Reports/` + objectId, {
    params: {
      keys: 'objectId,ringDataVer,ringOriginalData,updatedAt,createdAt'
    }
  })
}

export {
  parse,
  getSpoList,
  getSpoListCounts,
  getByObjectId
}



// WEBPACK FOOTER //
// ./src/services/MjService.js